(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[335],{

/***/ 8367:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/contact",
      function () {
        return __webpack_require__(6741);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 4530:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var country_calling_code__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8187);
/* harmony import */ var _Contact_module_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5792);
/* harmony import */ var _Contact_module_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_Contact_module_css__WEBPACK_IMPORTED_MODULE_3__);




var ContactInput = function(param) {
    var value = param.value, _placeholder = param.placeholder, placeholder = _placeholder === void 0 ? "Select Country" : _placeholder, onChange = param.onChange, _required = param.required, required = _required === void 0 ? false : _required;
    var dropdownRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    var flagRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), show = ref[0], setShow = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({
        country: "India",
        countryCodes: [
            "91"
        ],
        isoCode2: "IN",
        isoCode3: "IND"
    }), selected = ref1[0], setSelected = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(country_calling_code__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP), countries = ref2[0], setCountries = ref2[1];
    var countryChangeHandler = function(e) {
        setCountries(country_calling_code__WEBPACK_IMPORTED_MODULE_2__/* ["default"].filter */ .ZP.filter(function(m) {
            return m.country.toLowerCase().includes(e.target.value.toLowerCase()) || m.countryCodes[0].toString().includes(e.target.value.toLowerCase());
        }));
    };
    var countrySelectHandler = function(c) {
        setSelected(c);
        setShow(false);
    };
    var countryClickHandler = function() {
        setShow(true);
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (show) {
            document.addEventListener("click", function(e) {
                if (!dropdownRef.current.contains(e.target) && !flagRef.current.contains(e.target)) {
                    setShow(false);
                }
            });
        }
    });
    var changeHandler = function(e) {
        onChange({
            code: selected.countryCodes[0],
            number: e.target.value,
            country: selected.isoCode2
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "".concat((_Contact_module_css__WEBPACK_IMPORTED_MODULE_3___default().contactComponent), " contactInput mt-4 mb-4"),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (_Contact_module_css__WEBPACK_IMPORTED_MODULE_3___default().container),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        ref: flagRef,
                        className: "ms-0",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                onClick: countryClickHandler,
                                children: selected && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                    alt: selected.country,
                                    src: "http://purecatamphetamine.github.io/country-flag-icons/3x2/".concat(selected.isoCode2.toUpperCase(), ".svg"),
                                    width: "23px"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                className: "coucode",
                                onClick: countryClickHandler,
                                children: [
                                    "+",
                                    selected.countryCodes[0] || "91 "
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                        type: "number",
                        onInput: function(e) {
                            return e.target.value = e.target.value.slice(0, 10);
                        },
                        value: value,
                        onChange: changeHandler,
                        className: (_Contact_module_css__WEBPACK_IMPORTED_MODULE_3___default().contactInput2),
                        required: required
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                ref: dropdownRef,
                className: "".concat((_Contact_module_css__WEBPACK_IMPORTED_MODULE_3___default().dropdown), " ").concat(show && (_Contact_module_css__WEBPACK_IMPORTED_MODULE_3___default().show)),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                        onChange: countryChangeHandler,
                        placeholder: "Search"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (_Contact_module_css__WEBPACK_IMPORTED_MODULE_3___default().dropdownContent),
                        children: countries.map(function(c) {
                            if (c.country === "Netherlands Antilles") return;
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                onClick: function() {
                                    return countrySelectHandler(c);
                                },
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                        alt: c.country,
                                        src: "http://purecatamphetamine.github.io/country-flag-icons/3x2/".concat(c.isoCode2, ".svg"),
                                        width: "24px"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                        className: "gray",
                                        style: {
                                            marginRight: "4px"
                                        },
                                        children: [
                                            "+ ",
                                            c.countryCodes[0]
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        children: c.country
                                    })
                                ]
                            }, c.isoCode3);
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ContactInput);


/***/ }),

/***/ 6741:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(7568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(1799);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(9396);
/* harmony import */ var _vercel_path0_frontend_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4051);
/* harmony import */ var _vercel_path0_frontend_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_vercel_path0_frontend_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7294);
/* harmony import */ var _fortawesome_free_solid_svg_icons__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(1436);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7814);
/* harmony import */ var _store_store__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(6428);
/* harmony import */ var libphonenumber_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(6346);
/* harmony import */ var _utils_urls_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(1510);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _components_ContactInput__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(4530);














var Contact = function() {
    var showNotification = (0,_store_store__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function(state) {
        return state.showNotification;
    });
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(null), phone = ref[0], setPhone = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), loading = ref1[0], setLoading = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)({
        name: "",
        email: "",
        message: ""
    }), data = ref2[0], setData = ref2[1];
    var isValidPhoneNumber = function(p) {
        var phoneNumber = (0,libphonenumber_js__WEBPACK_IMPORTED_MODULE_9__/* .parsePhoneNumberFromString */ ._)(p.code + "" + p.number, p.country);
        return phoneNumber.isValid();
    };
    var sendHandler = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(_vercel_path0_frontend_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(e) {
            return _vercel_path0_frontend_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        e.preventDefault();
                        if (!(!phone || !isValidPhoneNumber(phone))) {
                            _ctx.next = 4;
                            break;
                        }
                        alert("Phone Number Not Valid");
                        return _ctx.abrupt("return");
                    case 4:
                        _ctx.prev = 4;
                        setLoading(true);
                        _ctx.next = 8;
                        return axios__WEBPACK_IMPORTED_MODULE_3___default().post(_utils_urls_js__WEBPACK_IMPORTED_MODULE_6__/* .baseUrl */ .F + "/api/v1/messages/", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, data), {
                            phone: phone.number
                        }));
                    case 8:
                        showNotification("Message Sent!");
                        setLoading(false);
                        setPhone((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, phone), {
                            number: ""
                        }));
                        setData(null);
                        _ctx.next = 19;
                        break;
                    case 14:
                        _ctx.prev = 14;
                        _ctx.t0 = _ctx["catch"](4);
                        console.log(_ctx.t0);
                        showNotification("Some Error Occured!");
                        setLoading(false);
                    case 19:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    4,
                    14
                ]
            ]);
        }));
        return function sendHandler(e) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_7___default()), {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
                        property: "og:image",
                        content: "https://assets.alanvidyushbaptist.com/optimumwellness_logo.jpg"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("title", {
                        children: "Contact Us | Diet Consultant and Fitness Expert"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
                        name: "description",
                        content: "Fill this form and we'll get back to you as soon as possible. You can also call or whatsapp us or even email us to book an appointment."
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
                        name: "keywords",
                        content: "fitness, health, wellness"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                        className: "row m-0 pt-3 pt-xl-0",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                className: "col-md-1 col-xl-2 col-xxl-1"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                className: "col-md-4 col-xl-4 col-xxl-4 m-auto ps-3 pe-3 ps-md-0 pe-md-0",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("h1", {
                                        className: "fo-46 bco fw-700 lg-40 mfo-32",
                                        children: [
                                            "We’d love to ",
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("br", {}),
                                            "hear from you."
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("form", {
                                        onSubmit: sendHandler,
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("input", {
                                                required: true,
                                                className: "contactInput mt-4",
                                                placeholder: "Name",
                                                value: data ? data.name : "",
                                                onChange: function(e) {
                                                    return setData((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, data), {
                                                        name: e.target.value
                                                    }));
                                                }
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_ContactInput__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                                    value: phone && phone.number,
                                                    onChange: function(value) {
                                                        return setPhone(value);
                                                    },
                                                    required: true
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("input", {
                                                type: "email",
                                                className: "contactInput",
                                                placeholder: "Email",
                                                required: true,
                                                value: data ? data.email : "",
                                                onChange: function(e) {
                                                    return setData((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, data), {
                                                        email: e.target.value
                                                    }));
                                                }
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("textarea", {
                                                className: "contactTextarea mt-4",
                                                placeholder: "Your Message (Optional)",
                                                value: data ? data.message : "",
                                                onChange: function(e) {
                                                    return setData((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, data), {
                                                        message: e.target.value
                                                    }));
                                                }
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("button", {
                                                type: "submit",
                                                className: "btn sendButton pulsating",
                                                disabled: loading,
                                                children: "Send"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                className: "col-md-7 col-xl-1 col-xxl-0 p-0 d-xxl-none"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                className: "col-md-7 col-xl-5 col-xxl-7 m-auto p-0",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("img", {
                                    src: "/assets/contact.png",
                                    className: "w-100",
                                    alt: "contactImage"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                        className: "ps-xl-5 pe-xl-5 mt-5",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                            className: "ps-xl-5 pe-xl-5",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                className: "row m-0 ps-xl-5 pe-xl-5",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                        className: "col-md-4 text-center mb-5",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                className: "contactIcon",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_4__/* .FontAwesomeIcon */ .G, {
                                                    icon: _fortawesome_free_solid_svg_icons__WEBPACK_IMPORTED_MODULE_13__/* .faPhone */ .j1w
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                className: "fo-16 fw-600 bco mt-3",
                                                children: "+91-9836143134"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                        className: "col-md-4 text-center mb-5",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                className: "contactIcon",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_4__/* .FontAwesomeIcon */ .G, {
                                                    icon: _fortawesome_free_solid_svg_icons__WEBPACK_IMPORTED_MODULE_13__/* .faMapMarkerAlt */ .FGq
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                className: "fo-16 fw-600 bco mt-3",
                                                children: "77/C Dilkhusha Street, Kolkata, 700017, India"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                        className: "col-md-4 text-center mb-5",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                className: "contactIcon",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_4__/* .FontAwesomeIcon */ .G, {
                                                    icon: _fortawesome_free_solid_svg_icons__WEBPACK_IMPORTED_MODULE_13__/* .faEnvelope */ .FU$
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                className: "fo-16 fw-600 bco mt-3",
                                                children: "contact@optimumwellness.in"
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (Contact);


/***/ }),

/***/ 1510:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ baseUrl; }
/* harmony export */ });
var baseUrl = "https://itchy-blue-seagull.cyclic.app";
// export const domainUrl = "https://optimumwellness.in";
// export const baseUrl = `http://localhost:8081`;
// http://localhost:8081
var urlSet = {
    // Blogs
    get_blogApi: {
        // Get blogs
        url: baseUrl + "/api/v1/blogs",
        method: "GET"
    },
    post_blogApi: {
        // Add a new blog
        url: baseUrl + "/api/v1/blogs/",
        method: "POST"
    },
    edit_blogApi: {
        // Edit blog
        url: baseUrl + "/api/v1/blogs/",
        method: "PATCH"
    },
    delete_blogApi: {
        // Delete a blog
        url: baseUrl + "/api/v1/blogs/",
        method: "DELETE"
    },
    get_AuthorblogApi: {
        // Get blogs of an author
        url: baseUrl + "/api/v1/blogs/author/",
        method: "GET"
    },
    get_featuredblogApi: {
        // Get featured blogs
        url: baseUrl + "/api/v1/blogs/featured",
        method: "GET"
    },
    data_intervalApi: {
        // set data interval
        url: baseUrl + "/api/v1/blogs/updateDataInterval",
        method: "PATCH"
    },
    // Admin
    adminLoginApi: {
        // Admin login
        url: baseUrl + "/api/v1/auth/api/v1/auth/login",
        method: "POST"
    },
    adminUpdateApi: {
        // Admin login
        url: baseUrl + "/api/v1/auth/api/v1/auth/update",
        method: "PATCH"
    },
    // Admin blogs
    add_blog_to_featuredApi: {
        // Add to featured blogs
        url: baseUrl + "/api/v1/admin/featuredBlog/",
        method: "PATCH"
    },
    delete_blog_from_featuredApi: {
        // Delete from featured blogs
        url: baseUrl + "/api/v1/admin/featuredBlog/",
        method: "DELETE"
    },
    // Admin services
    viewServicesApi: {
        // To get services
        url: baseUrl + "/api/v1/admin/service/",
        method: "GET"
    },
    getMainServiceApi: {
        // To get services based on level
        url: baseUrl + "/api/v1/admin/service",
        method: "GET"
    },
    addServiceApi: {
        // To add new service
        url: baseUrl + "/api/v1/admin/service",
        method: "POST"
    },
    deleteServiceApi: {
        // To delete services
        url: baseUrl + "/api/v1/admin/service/",
        method: "DELETE"
    },
    editServicesApi: {
        // Update service names
        url: baseUrl + "/api/v1/admin/service/",
        method: "PATCH"
    },
    // Admin offers
    editOffersApi: {
        // Update offer
        url: baseUrl + "/api/v1/admin/offer/",
        method: "PATCH"
    },
    deleteOffersApi: {
        // Delete offer
        url: baseUrl + "/api/v1/admin/offer/",
        method: "DELETE"
    },
    // Admin coupons
    viewCouponsApi: {
        // Get all coupons
        url: baseUrl + "/api/v1/admin/coupon",
        method: "GET"
    },
    addCouponsApi: {
        // Add new coupon
        url: baseUrl + "/api/v1/admin/coupon/",
        method: "POST"
    },
    deleteCouponsApi: {
        // Delete a coupon
        url: baseUrl + "/api/v1/admin/coupon/",
        method: "DELETE"
    },
    // Payments
    applyCouponApi: {
        // Apply coupon
        url: baseUrl + "/api/v1/payment/applyCoupon",
        method: "POST"
    },
    paymentApi: {
        // Create payment order id
        url: baseUrl + "/api/v1/payment/generateReceipt",
        method: "POST"
    },
    verifyPaymentApi: {
        // Verify payments status after razorpay
        url: baseUrl + "/api/v1/payment/verifyPayment",
        method: "POST"
    },
    // Admin transactions
    viewTransactionsApi: {
        // View all transactions
        url: baseUrl + "/api/v1/transaction",
        method: "GET"
    },
    addTransactionsApi: {
        // Add transactions
        url: baseUrl + "/api/v1/transaction/",
        method: "POST"
    },
    updateTransactionsApi: {
        // Update transactions
        url: baseUrl + "/api/v1/transaction/",
        method: "PATCH"
    },
    deleteTransactionsApi: {
        // Delete transactions
        url: baseUrl + "/api/v1/transaction/",
        method: "DELETE"
    },
    // Add employees
    viewEmployeesApi: {
        // Get all employees
        url: baseUrl + "/api/v1/employees/?index=0&limit=50",
        method: "GET"
    }
};
/* harmony default export */ __webpack_exports__["Z"] = (urlSet);


/***/ }),

/***/ 5792:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"contactComponent":"Contact_contactComponent___mbT2","container":"Contact_container__TvrFr","contactInput2":"Contact_contactInput2__271RP","dropdown":"Contact_dropdown__SpecU","dropdownContent":"Contact_dropdownContent___VBtL","show":"Contact_show__GgsaE"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [217,187,346,774,888,179], function() { return __webpack_exec__(8367); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);